<template>
    <span>
        <i-switch v-model="val" @on-change="change">
            <span slot="open">开</span>
            <span slot="close">关</span>
        </i-switch>
    </span>
</template>
<script>
    export default {
        props: {
            value: {
                type: Boolean
            }
        },
        data() {
            return {
                val: "",
            }
        },
        watch: {
            value: {
                handler(value) {
                    this.val = value;
                },
                immediate: true
            }
        },
        methods: {
            change(val) {
                this.$emit("input", val);
                this.$emit('save');
            }
        }
    }
</script>